"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function About(_ref) {
  var i18n = _ref.i18n,
      about = _ref.about,
      cards = _ref.cards;

  return _react2.default.createElement(
    "div",
    null,
    about.map(function (item) {
      return _react2.default.createElement(
        "div",
        { className: "about-checkin", key: item.label },
        _react2.default.createElement(
          "div",
          { className: "inline-title-box" },
          _react2.default.createElement(
            "h3",
            null,
            item.label
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "inline-content-box" },
          item.text && _react2.default.createElement(
            "span",
            null,
            item.text
          ),
          item.list && item.list.length > 0 && _react2.default.createElement(
            "ul",
            null,
            item.list.map(function (item) {
              return _react2.default.createElement(
                "li",
                { key: item.title },
                _react2.default.createElement(
                  "span",
                  { className: "contact-title" },
                  item.title,
                  " "
                ),
                _react2.default.createElement(
                  "span",
                  { className: "contact-detail" },
                  item.detail
                )
              );
            })
          )
        )
      );
    }),
    cards.length > 0 ? _react2.default.createElement(
      "div",
      { className: "about-accepted-credit-cards" },
      _react2.default.createElement(
        "div",
        { className: "inline-title-box" },
        _react2.default.createElement(
          "h3",
          null,
          i18n.hotelInformation.acceptedCredit
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "inline-content-box" },

        /* TODO: change img links */
        cards.map(function (card) {
          return _react2.default.createElement("img", {
            src: "https://img.travel.rakuten.co.jp/m17n/share/img/common/" + card.id + ".png",
            className: "credit-card-logo",
            alt: "",
            key: card.id
          });
        })
      )
    ) : null
  );
} // About

About.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  about: _react.PropTypes.array.isRequired,
  cards: _react.PropTypes.array.isRequired
};

exports.default = About;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/About.js
// module id = 1192
// module chunks = 0